import {
  ADMIN_PRICING_FETCH,
  ADMIN_PRICING_FETCH_SUCCESS,
  ADMIN_PRICING_FETCH_FAIL,
  ADMIN_PRICING_UPLOAD,
  ADMIN_PRICING_UPLOAD_SUCCESS,
  ADMIN_PRICING_UPLOAD_FAIL,
  ADMIN_PRICING_DELETE,
  ADMIN_PRICING_DELETE_SUCCESS,
  ADMIN_PRICING_DELETE_FAIL,
  ADMIN_PRICING_SET_SORT,
  ADMIN_PRICING_SET_PRICE,
  ADMIN_PRICING_SET_PRICE_SUCCESS,
  ADMIN_PRICING_SET_PRICE_FAIL
} from './constants';

export const fetchPricing = () => ({
  type: ADMIN_PRICING_FETCH
});
export const fetchPricingSuccess = pricings => ({
  type: ADMIN_PRICING_FETCH_SUCCESS, pricings
});
export const fetchPricingFail = () => ({
  type: ADMIN_PRICING_FETCH_FAIL
});
export const uploadPricing = pricing => ({
  type: ADMIN_PRICING_UPLOAD, pricing
});
export const uploadPricingSuccess = pricing => ({
  type: ADMIN_PRICING_UPLOAD_SUCCESS, pricing
});
export const uploadPricingFail = (pricing, error) => ({
  type: ADMIN_PRICING_UPLOAD_FAIL, pricing, error
});
export const deletePricing = pricing => ({
  type: ADMIN_PRICING_DELETE, pricing
});
export const deletePricingSuccess = () => ({
  type: ADMIN_PRICING_DELETE_SUCCESS
});
export const deletePricingFail = (pricing, error) => ({
  type: ADMIN_PRICING_DELETE_FAIL, pricing, error
});
export const setPricingSort = attribute => ({
  type: ADMIN_PRICING_SET_SORT, attribute
});
export const setFarmGatePrice = (pricingId, priceInPennies) => ({
  type: ADMIN_PRICING_SET_PRICE, priceInPennies, pricingId
});
export const setFarmGatePriceSuccess = id => ({
  type: ADMIN_PRICING_SET_PRICE_SUCCESS, id
});
export const setFarmGatePriceFail = pricing => ({
  type: ADMIN_PRICING_SET_PRICE_FAIL, pricing
});